import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-date-picker";

// Components
import Text from "../../../../../components/base/Text";
import TextArea from "../../../../../components/base/TextArea";
import Phone from "../../../../../components/base/Phone";

// Helper

class AccountFormFields extends Component {
  constructor(props) {
    super(props);
  }

  // Render the form fields
  render() {
    return (
      <div>
        <div className="card bg-white mt-3 mb-3">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-6 col-sm-12">
                <div>
                  <Text
                    name="salesforceId"
                    label="Salesforce Id"
                    error=""
                    disabled
                  />
                </div>
                <div>
                  <Text name="name" label="Name" error="" disabled />
                </div>
                <div>
                  <Phone name="phone" label="Phone" error="" disabled />
                </div>
                <div>
                  <Text
                    name="billingCity"
                    label="Billing City"
                    error=""
                    disabled
                  />
                </div>
                <div>
                  <Text
                    name="billingState"
                    label="Billing State"
                    error=""
                    disabled
                  />
                </div>
                <div>
                  <Text
                    name="billingCountry"
                    label="Billing Country"
                    error=""
                    disabled
                  />
                </div>
                <div>
                  <TextArea
                    name="description"
                    label="Description"
                    error=""
                    disabled
                  />
                </div>
                {this.props.salesforceTerritoryFieldName && (
                  <div>
                    <Text
                      name="territoryId"
                      label="Territory Id"
                      error=""
                      disabled
                    />
                  </div>
                )}
                <div>
                  <Text
                    name="createdById"
                    label="Created By Id"
                    error=""
                    disabled
                  />
                </div>
                <div>
                  <Text name="ownerId" label="Owner Id" error="" disabled />
                </div>
                <div>
                  <Text name="isDeleted" label="Is Deleted" error="" disabled />
                </div>
                <div className="w-100 mb-2">
                  <div>
                    <label>Created Date</label>
                  </div>
                  <DatePicker
                    name="createdDate"
                    className="datepicker"
                    dayPlaceholder="MM/DD/YYYY"
                    value={
                      this.props.accountDetails &&
                      this.props.accountDetails.CreatedDate
                    }
                    clearIcon={null}
                    disabled
                  />
                </div>
                <div className="w-100 mb-2">
                  <div>
                    <label>Last Modified Date</label>
                  </div>
                  <DatePicker
                    name="lastModifiedDate"
                    className="datepicker"
                    dayPlaceholder="MM/DD/YYYY"
                    value={
                      this.props.accountDetails &&
                      this.props.accountDetails.LastModifiedDate
                    }
                    clearIcon={null}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountFormFields;
